<template><span></span></template>

<script>
import { LayoutStep } from '../../store/modules/configurator/layout';
import {
  ConfiguratorGetters,
  mapGetters as mapConfiguratorGetters,
} from '../../store/modules/configurator';
import {
  GlassesGetter,
  prefixType as prefixGlassType,
} from '../../store/modules/configurator/glasses';

export default {
  name: 'ConfiguratorTracking',
  computed: {
    activeStep() {
      return this.$store.state.configurator.layout.activeStep;
    },
    ...mapConfiguratorGetters({
      activeProductVariant: ConfiguratorGetters.GET_ACTIVE_PRODUCT_VARIANT,
      activeSize: ConfiguratorGetters.GET_ACTIVE_SIZE,
      activeProduct: ConfiguratorGetters.GET_ACTIVE_PRODUCT,
      activeQuantity: ConfiguratorGetters.GET_ACTIVE_QUANTITY,
      activeCategory: ConfiguratorGetters.GET_ACTIVE_CATEGORY,
      activeCategoryPathName: ConfiguratorGetters.GET_ACTIVE_CATEGORY_PATH_NAME,
      selectedProductIndex: ConfiguratorGetters.GET_SELECTED_PRODUCT_INDEX,
      price: ConfiguratorGetters.GET_PRICE,
    }),
    activeProductFirstCategory() {
      if (!this.activeProduct.firstCategory) {
        return null;
      }

      return this.$store.getters[
        prefixGlassType(GlassesGetter.FIND_CATEGORY_BY_ID)
      ](this.activeProduct.firstCategory);
    },
    activeProductSecondCategory() {
      if (!this.activeProduct.secondCategory) {
        return null;
      }

      return this.$store.getters[
        prefixGlassType(GlassesGetter.FIND_CATEGORY_BY_ID)
      ](this.activeProduct.secondCategory);
    },
  },
  watch: {
    activeStep() {
      this.trackActiveStep();
    },
  },
  mounted() {
    this.trackActiveStep();
  },
  methods: {
    trackActiveStep() {
      switch (this.activeStep) {
        case LayoutStep.STEP_FORMAT:
          globalThis.dispatchEvent(new CustomEvent('lgf.configurator.init'));
          globalThis.dispatchEvent(
            new CustomEvent('lgf.configurator.stepVisual')
          );
          break;
        case LayoutStep.STEP_CONTENT:
          this.trackStepContent();
          break;
      }
    },
    trackStepContent() {
      globalThis.dispatchEvent(
        new CustomEvent('lgf.configurator.stepContent', {
          detail: {
            ecommerce: {
              items: [
                {
                  item_name: this.activeProduct.name,
                  item_id: this.activeProduct.sku,
                  price: this.activeProductVariant.unitPrice,
                  item_category: this.activeProductFirstCategory
                    ? this.activeProductFirstCategory.name
                    : null,
                  item_category2: this.activeProductSecondCategory
                    ? this.activeProductSecondCategory.name
                    : null,
                  index: this.selectedProductIndex,
                  quantity: Number.parseInt(this.activeQuantity.name),
                  item_list_name: this.activeCategoryPathName,
                  item_list_id: this.activeCategory
                    ? this.activeCategory.id
                    : null,
                },
              ],
            },
          },
        })
      );
    },
  },
};
</script>
